<template>
	<div class="estornar-item-adesao">
		<v-row>
			<v-col cols="12">
				<span class="font-weight-bold">
					<label-personalizado nome-campo="Código"></label-personalizado>
				</span>
				<div class="py-1">{{ getCodigoItens() }}</div>
			</v-col>
		</v-row>
		<v-row v-if="listaPossuiUmItem">
			<v-col cols="12">
				<label-personalizado nome-campo="Quantidade" obrigatorio-por-padrao></label-personalizado>
				<az-money
					v-model="form.quantidadeEstorno"
					:precision="numeroCasasDecimaisQtde"
					:negative="false"
					prefix=""
					class="cell-editable"
					dense
				>
				</az-money>
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="12">
				<label-personalizado nome-campo="Justificativa" obrigatorio-por-padrao></label-personalizado>
				<v-text-field
					:rules="regraFormularioJustificativa"
					placeholder="Informe a justificativa"
					v-model="form.justificativa"
					class="ma-0 py-0"
					maxlength="300"
					counter="300"
				></v-text-field>
			</v-col>
		</v-row>
	</div>
</template>
<script>
import { mutationTypes } from '@/core/constants'
import { mapState } from 'vuex'
import validacaoFormulario from '@/views/mixins/validacaoFormulario'
import LabelPersonalizado from '@/views/components/LabelPersonalizado.vue'

export default {
	name: 'estornar-item-adesao',
	components: { LabelPersonalizado },
	mixins: [validacaoFormulario],
	props: {
		itens: {
			type: Array,
			required: true,
		},
		listaPossuiUmItem: {
			type: Boolean,
			required: true,
		},
	},
	data() {
		return {
			regraFormularioJustificativa: [
				(valor) => this.regraObrigatoriedade(valor, 'Justificativa é obrigatória.'),
				(valor) =>
					this.regraDeTamanhoMaximoString(
						valor,
						300,
						'O campo de justificativa deve ser igual ou menor que 300 caracteres!',
					),
			],
		}
	},
	computed: {
		...mapState({
			numeroCasasDecimaisQtde: (state) => state.adesao.informacoesAdesao.numeroCasasDecimaisQtde,
		}),
		form: {
			set(newForm) {
				this.$store.commit(mutationTypes.ADESAO.ITENS.ESTORNO.ESTORNAR.SET_FORM, newForm)
			},
			get() {
				return this.$store.state.adesao.itensAdesao.estorno.estornar.form
			},
		},
	},
	mounted() {
		this.$emit('limpar-formulario')
		this.form.itensAdesao = this.itens
	},
	methods: {
		getCodigoItens() {
			return this.itens.map((item) => item.codigo).toString()
		},
	},
}
</script>
<style lang="stylus" scoped>
.estornar-item-adesao {
	.row {
		margin-top: 0 !important
	}
}
</style>
